export default __webpack_public_path__ + "static/media/muscles.f4f95a5e.svg";